import React from "react";
import { Layers } from "lucide-react";
import SolutionPageLayout from "./SolutionPageLayout";

// Pathway 1 (Family A) — Universities, Hospitals, Chambers, Unions & Multi-Department Institutions
const StructuredInstitutions = () => (
  <SolutionPageLayout
    testId="page-solution-structured-institutions"
    icon={Layers}
    overline="Pathway · 01 of 07 · Aligned with Family A"
    title="For Universities, Hospitals, Chambers, Unions & Multi-Department Institutions"
    headline="Clearer coordination across departments, services, documents, internal workflows, assets, reporting, and management visibility."
    intro={[
      "For universities, hospitals, professional chambers, business associations, unions, public-interest organizations, large campuses, and multi-department institutions that need clearer coordination across departments, services, documents, internal workflows, assets, reporting, and management visibility.",
      "This pathway is designed for organizations that may not be municipalities or industrial zones, but still operate with complex institutional structures, committees, service units, member or stakeholder records, internal approvals, documents, meetings, assets, and reporting needs.",
    ]}
    supportsOverline="Relevant use cases may include"
    supportsTitle="Where this pathway creates institutional value."
    supports={[
      "Multi-department institutional management",
      "University, hospital, chamber, union, association, or campus-style operating structures",
      "Committee, meeting, decision, and follow-up management",
      "Internal service definitions and workflow control",
      "Document and archive continuity",
      "Member, patient, stakeholder, or institutional record structures where applicable",
      "Quality management and strategic planning",
      "Management dashboards and executive reporting",
      "Phased institutional digitization",
    ]}
    ctaTitle="Bring multi-department institutional operations into a clearer digital structure."
    primaryCta={{ label: "Discuss Your Institution", to: "/contact" }}
    secondaryCta={{ label: "View Product Portfolio", to: "/product-portfolio#institutional-management-platforms" }}
  />
);

export default StructuredInstitutions;
